<template>
  <v-dialog
    persistent
    v-model="show"
    max-width="1520px"
    content-class="popup-wrap-1"
  >
    <div class="pa-8">
      <!-- 달력 -->
      <div class="calendar-info d-flex justify-space-between">
        <div class="calendar-month d-flex align-center">
          <div class="month d-flex align-center">
            <!--<a href="" @click.prevent="onCalendarArrow(-1)">
							<v-icon class="arrow">mdi-chevron-left</v-icon>
						</a>-->
            <span>
              <v-icon>mdi-calendar-blank</v-icon>
              {{ year }}년 {{ month }}월
            </span>
            <!--<a href="" @click.prevent="onCalendarArrow(1)">
							<v-icon class="arrow">mdi-chevron-right</v-icon>
						</a>-->
          </div>
          <div style="font-weight: normal; margin-left: 12px">
            조회 시점의 부킹 현황이며 등록 하는 사이 다른 캠페인이 집행 될 수
            있습니다.
          </div>
        </div>
        <!-- <div class="cell-info d-flex align-center">
					<p class="advertiser">
						광고주/대행사(확정)
					</p>
					<p class="inside ml-4">
						내부 광고(조정)
					</p>
				</div> -->
      </div>
      <!-- //달력 -->
      <!-- <div v-if="bookingLists.length > 0"> -->
      <div class="calendar-wrap mt-2" v-if="bookingInventory">
        <vue-scroll>
          <table class="calendar-tb">
            <caption>
              부킹 현황 표
            </caption>
            <thead>
              <tr>
                <th scope="col" class="none"></th>
                <th scope="col" class="none"></th>
                <th
                  scope="col"
                  v-for="(c, i) in calendar"
                  :key="i"
                  class="cal-cell"
                >
                  <span class="day">{{ c.dd }}</span>
                  {{ c.ddd }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">{{ bookingInventory.name }}</th>
                <td :colspan="calendar.length + 1" class="pa-0">
                  <table>
                    <tr v-for="cnt in bookingInventory.overlap_cnt" :key="cnt">
                      <th>
                        {{
                          bookingInventory.campaigns[cnt - 1] &&
                          bookingInventory.campaigns[cnt - 1].name
                            ? bookingInventory.campaigns[cnt - 1].name
                            : ''
                        }}
                      </th>
                      <td v-for="(bk, j) in calendar.length" :key="j">
                        <a
                          href=""
                          v-if="bookingInventory.campaigns[cnt - 1]"
                          :class="[
                            campaignId ===
                              bookingInventory.campaigns[cnt - 1].id &&
                            j === campaignCellIdx &&
                            bookingInventory.id === mediaId
                              ? 'active'
                              : '',
                            cellCampaign(
                              bookingInventory.campaigns[cnt - 1].start_at,
                              bookingInventory.campaigns[cnt - 1].end_at,
                              j,
                              bookingInventory.campaigns[cnt - 1].agency,
                            ),
                          ]"
                          @click.prevent="
                            cellCampaign(
                              bookingInventory.campaigns[cnt - 1].start_at,
                              bookingInventory.campaigns[cnt - 1].end_at,
                              j,
                              bookingInventory.campaigns[cnt - 1].agency,
                            ) === 'none'
                              ? onPopupCampaignWrite(
                                  bookingInventory.name,
                                  bookingInventory.campaigns[cnt - 1].name,
                                  calendar[j].dd,
                                  bookingInventory.id,
                                  bookingInventory.campaigns[cnt - 1].id,
                                  j,
                                )
                              : onPopupCampaignIng(
                                  bookingInventory.campaigns[cnt - 1],
                                  bookingInventory.id,
                                  j,
                                )
                          "
                        ></a>
                        <a
                          href=""
                          v-else
                          class="none"
                          @click.prevent="
                            onPopupCampaignWrite(
                              bookingInventory.name,
                              '',
                              calendar[j].dd,
                              bookingInventory.id,
                              '',
                              j,
                            )
                          "
                        ></a>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </vue-scroll>
        <!-- </div> -->
      </div>
      <div class="d-flex justify-center mt-8">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click="show = false"
        >
          확인
        </v-btn>
      </div>
    </div>
    <!-- popup_진행중인캠페인 -->
    <v-dialog
      v-model="popCampaignIng.state"
      persistent
      width="320"
      content-class="popup-wrap-1"
    >
      <div class="pa-8">
        <p class="title-type-5">진행중인 캠페인</p>
        <ul class="pop-list">
          <li>
            <p class="property">캠페인 명</p>
            <p class="value">{{ popCampaignIng.name }}</p>
          </li>
          <li>
            <p class="property">기간</p>
            <p class="value">{{ popCampaignIng.period }}</p>
          </li>
          <li>
            <p class="property">광고주</p>
            <p class="value">{{ popCampaignIng.advertiser }}</p>
          </li>
          <li v-if="popCampaignIng.agency">
            <p class="property">대행사</p>
            <p class="value">{{ popCampaignIng.agency }}</p>
          </li>
        </ul>
        <div class="mt-6 text-center">
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fff"
            class="button-type-1"
            @click.prevent="cancelPopup(popCampaignIng.state)"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fecd06"
            class="button-type-1 ml-2"
            @click="onCampaignModify"
          >
            <v-icon left> mdi-pencil-outline </v-icon>
            캠페인 수정
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <!-- //popup_진행중인캠페인 -->

    <!-- popup_등록캠페인 -->
    <v-dialog
      v-model="popCampaignWrite.state"
      persistent
      width="320"
      content-class="popup-wrap-1"
    >
      <div class="pa-8">
        <p class="title-type-5">캠페인 등록 퀵메뉴</p>
        <ul class="pop-list">
          <li>
            <p class="property">선택 지면</p>
            <p class="value">
              {{ popCampaignWrite.name }} &gt;
              {{ popCampaignWrite.campaignName }}
            </p>
          </li>
          <li>
            <p class="property">선택 기간</p>
            <p class="value">
              {{ year }}. {{ month }}.
              {{ popCampaignWrite.day }}
            </p>
          </li>
        </ul>
        <div class="mt-6 text-center">
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fff"
            class="button-type-1"
            @click.prevent="cancelPopup(popCampaignWrite.state)"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fecd06"
            class="button-type-1 ml-2"
            @click="onCampaignMove"
          >
            <v-icon left> mdi-plus </v-icon>
            캠페인 등록
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <!-- //popup_등록캠페인 -->
  </v-dialog>
</template>

<script>
import moment from 'moment';
import tz from 'moment-timezone';
import '../../assets/scss/booking.scss';
import { bookingMediaList } from '@/api/booking';

let today = new Date();
let d_Year = today.getFullYear();
let d_month = today.getMonth() + 1;
d_month = d_month.length !== 1 ? `0${d_month}` : `${d_month}`;
let standard = `${d_Year}${d_month}`;

export default {
  props: {
    value: Boolean,
    propsItem: Object,
    propsMediaId: String,
  },
  data: () => ({
    yearMonth: standard,
    year: '',
    month: '',

    calendar: [],
    bookingLists: [],
    bookingInventory: {},
    campaignId: '',
    popCampaignWrite: {
      state: false,
      name: '',
      campaignName: '',
      day: '',
    },

    popCampaignIng: {
      state: false,
      name: '',
      period: '',
      advertiser: '',
      agency: '',
    },
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    inventory: {
      get() {
        return this.propsItem;
      },
      set(value) {
        this.propsItem = value;
      },
    },
  },
  methods: {
    confirm() {
      this.show = false;
    },
    getDateSetting() {
      moment.updateLocale('ko', {
        weekdays: [
          '일요일',
          '월요일',
          '화요일',
          '수요일',
          '목요일',
          '금요일',
          '토요일',
        ],
        weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
      });

      const startOfMonth = moment(this.yearMonth)
        .startOf('month')
        .format('YYYY-MM-DD ddd');
      const endOfMonth = moment(this.yearMonth)
        .endOf('month')
        .format('YYYY-MM-DD ddd');
      const year = moment(this.yearMonth).startOf('month').format('YYYY');
      const month = moment(this.yearMonth).startOf('month').format('MM');
      const yearMonth = moment(this.yearMonth)
        .startOf('month')
        .format('YYYYMM');
      const endDayNum = moment(this.yearMonth).endOf('month').format('DD');

      this.yearMonth = yearMonth;

      this.year = year;
      this.month = month;

      const calendarLists = [];
      this.calendar = [];

      for (let i = 0; i < endDayNum; i++) {
        calendarLists.push({
          mmdd: moment(this.yearMonth).add(i, 'days').format('MMDD'),
          dd: moment(this.yearMonth).add(i, 'days').format('DD'),
          ddd: moment(this.yearMonth).add(i, 'days').format('ddd'),
          yymmdd: moment(this.yearMonth)
            .add(i, 'days')
            .tz('Asia/Seoul')
            .format('YYMMDD'),
        });
      }

      this.calendar = calendarLists;
    },
    onCalendarArrow(move) {
      this.yearMonth = moment(standard).add(move, 'months').format('YYYYMM');

      this.getDateSetting();
    },
    cellCampaign(start_at, end_at, i, agency) {
      const dayS = parseInt(moment(start_at).tz('Asia/Seoul').format('YYMMDD'));
      const dayE = parseInt(moment(end_at).tz('Asia/Seoul').format('YYMMDD'));
      const calendar = parseInt(this.calendar[i].yymmdd);
      return dayS <= calendar && dayE >= calendar
        ? agency
          ? 'agency'
          : 'inside'
        : 'none';
    },
    onPopupCampaignWrite(name, campaignName, day, mediaId, id, j) {
      this.popCampaignWrite = {
        state: true,
        name,
        campaignName,
        day,
      };
      this.mediaId = mediaId;
      this.campaignId = id;
      this.campaignCellIdx = j;
    },
    onPopupCampaignIng(campaign, mediaId, j) {
      this.popCampaignIng = {
        state: true,
        name: campaign.name,
        period: `${moment(campaign.start_at).format('YYYY.MM.DD')} ~ ${moment(
          campaign.end_at,
        ).format('YYYY.MM.DD')}`,
        advertiser: campaign.advertiser.name,
        agency: campaign.agency ? campaign.agency.name : '',
      };
      this.mediaId = mediaId;
      this.campaignId = campaign.id;
      this.campaignCellIdx = j;
    },
    onCampaignMove() {
      this.$router.push(`/campaign/register`);
    },
    onCampaignModify() {
      this.$router.push(`/campaign/${this.campaignId}/modify`);
    },
    cancelPopup() {
      this.popCampaignWrite.state = false;
      this.popCampaignIng.state = false;
    },
    async getBookingLists() {
      try {
        const { data } = await bookingMediaList(
          this.propsMediaId,
          this.yearMonth,
        );

        if (data.list.length > 0) {
          this.bookingLists = data.list;
          data.list.forEach(bookingItem => {
            if (bookingItem.id === this.inventory.id) {
              this.bookingInventory = bookingItem;
            }
          });
        } else {
          this.showSystemAlert = true;
          this.logResult = '조회된 목록이 없습니다.';
        }
      } catch (error) {
        console.log(error.response);
      }
    },
  },
  created() {
    this.getDateSetting();
    this.getBookingLists();
  },
};
</script>

<style lang="scss" scoped>
.previewImage {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 360px;
    max-height: 640px;
  }
}
</style>
